import React from "react";
import { cn } from "./cn";

/** Cohesive table primitives. Wrap rows in <Table><THead/><TBody/></Table>. */
export function Table({ className, children, wrapperClassName }) {
  return (
    <div className={cn("overflow-hidden rounded-2xl border border-line bg-surface shadow-card", wrapperClassName)}>
      <div className="overflow-x-auto">
        <table className={cn("min-w-full text-sm", className)}>{children}</table>
      </div>
    </div>
  );
}

export function THead({ className, sticky = false, children }) {
  return (
    <thead
      className={cn(
        "bg-surface-2 [&_th]:border-b [&_th]:border-line",
        sticky && "sticky top-0 z-10",
        className
      )}
    >
      {children}
    </thead>
  );
}

export function TBody({ className, children }) {
  return <tbody className={cn("divide-y divide-line", className)}>{children}</tbody>;
}

export function TR({ className, children, ...props }) {
  return (
    <tr className={cn("transition-colors hover:bg-surface-2/70", className)} {...props}>
      {children}
    </tr>
  );
}

export function TH({ className, children, ...props }) {
  return (
    <th
      className={cn(
        "whitespace-nowrap px-5 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted",
        className
      )}
      {...props}
    >
      {children}
    </th>
  );
}

export function TD({ className, children, ...props }) {
  return (
    <td className={cn("px-5 py-3.5 text-ink", className)} {...props}>
      {children}
    </td>
  );
}

export function TableEmpty({ colSpan, children = "No records found." }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-5 py-12 text-center text-sm text-faint">
        {children}
      </td>
    </tr>
  );
}
